import { StatCard, CardLabel, CardValue, CardUnit, CardSub, ProgressBar, Divider, SubRow, SubStat, SubStatValue, SubStatLabel } from './StatCard'
import useBotBalance from '../../../hooks/useBotBalance'
import useNetworkInfo from '../../../hooks/useNetworkInfo'
import { ChainStatsResponse } from '../../../types/API'
import { BOT_MIN_BALANCES } from '../../../constants/networks'

export interface BotData {
  chainInfo?: ChainStatsResponse
  chainId: number
}

export default function Bot({ chainId, chainInfo }: BotData) {
  const { data, isLoading } = useBotBalance(chainId)
  const { data: networkInfo } = useNetworkInfo(chainId)

  if (isLoading || !data) return <StatCard />

  const balance = Number(data.balance)
  const min = BOT_MIN_BALANCES[chainId] || 0.1
  const ok = balance >= min
  const percent = (balance * 100) / (min * 15)
  const remainingTx =
    data.balanceUsd && chainInfo?.averageTxCost
      ? (Number(data.balanceUsd) / Number(chainInfo.averageTxCost)).toFixed(0)
      : null

  return (
    <StatCard>
      <CardLabel>Bot Balance</CardLabel>
      <CardValue>
        {data.balance}
        <CardUnit>{networkInfo?.symbol}</CardUnit>
      </CardValue>
      <CardSub>$ {data.balanceUsd}</CardSub>
      <ProgressBar percent={percent} ok={ok} />
      <Divider />
      <SubRow>
        <SubStat>
          <SubStatValue>$ {chainInfo?.averageTxCost?.toFixed(2) || '—'}</SubStatValue>
          <SubStatLabel>Avg tx cost</SubStatLabel>
        </SubStat>
        {remainingTx && (
          <SubStat>
            <SubStatValue>{remainingTx}</SubStatValue>
            <SubStatLabel>Remaining tx</SubStatLabel>
          </SubStat>
        )}
      </SubRow>
    </StatCard>
  )
}
